import { useEffect, useState } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import { Box, Button, Grid, Typography, TextField, Select, MenuItem, Autocomplete, CircularProgress, Checkbox, FormControl } from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';
import { gridSpacing } from 'app/constant';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import StickyHeadTable from './components/StickyHeadTable';
import { warningAlert, successAlert, errorAlert } from 'ui-component/Toasts';
import useFetchData from 'hooks/useFetchData';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import * as XLSX from 'xlsx';

const EarnWalletInvestment = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();

    console.log(token);

    const [walletInvestment, setWalletInvestment] = useState([]);
    const [filterDateFrom, setFilterDateFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterDateTo, setFilterDateTo] = useState(dayjs());
    const [isLoading, setLoading] = useState(false);
    const [filterLoginUsername, setFilterLoginUsername] = useState('');
    const [filterIsWithdraw, setFilterIsWithdraw] = useState('');
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const fetchWalletInvestmentRecord = async () => {
        if (!filterDateFrom.isValid() || !filterDateTo.isValid()) {
            warningAlert('Please fill up all required fields.');
            return;
        }
        let fetchWalletInvestmentUrl = `/EarnWalletInvestment/All?createdDateFrom=${filterDateFrom.format(
            'YYYY-MM-DD'
        )}&createdDateTo=${filterDateTo.format('YYYY-MM-DD')}`;
       
        if (filterLoginUsername !== '') {
            fetchWalletInvestmentUrl += `&loginUserName=${filterLoginUsername}`;
        }

        if (filterIsWithdraw !== '') {
            fetchWalletInvestmentUrl += `&isWithdraw=${filterIsWithdraw}`;
        }

        setLoading(true);
        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(fetchWalletInvestmentUrl, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setWalletInvestment(res.data);
                console.log(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
            setFilterBtnDisabled(false);
        }
    };

    const [exportDataListLoading, setExportDataListLoading] = useState(false);
    function convertDataForSheet(data) {
        if (!data || data.length === 0) {
            warningAlert('There is no data to export');
            throw new Error('Data array is empty or undefined.');
        }

        const headers = Object.keys(data[0]);
        const dataArray = [headers];

        data.forEach((item) => {
            const row = headers.map((key) => item[key]);
            dataArray.push(row);
        });

        return XLSX.utils.aoa_to_sheet(dataArray);
    }
    const exportDataAsXlsx = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        setExportDataListLoading(true);
        if (!filterDateFrom.isValid() || !filterDateTo.isValid()) {
            warningAlert('Please fill up all required fields.');
            return;
        }
        let fetchWalletInvestmentUrl = `/EarnWalletInvestment/All?createdDateFrom=${filterDateFrom.format(
            'YYYY-MM-DD'
        )}&createdDateTo=${filterDateTo.format('YYYY-MM-DD')}`;
       
        if (filterLoginUsername !== '') {
            fetchWalletInvestmentUrl += `&loginUserName=${filterLoginUsername}`;
        }

        if (filterIsWithdraw !== '') {
            fetchWalletInvestmentUrl += `&isWithdraw=${filterIsWithdraw}`;
        }
        try {
            const res = await axiosInstance.get(fetchWalletInvestmentUrl, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                const fileName = `Wallet_Investment_${dayjs().format('MM-DD-YYYY')}`;
                const workbook = XLSX.utils.book_new();
                const worksheet = convertDataForSheet(res.data);
                // Adjust column widths
                const headers = Object.keys(res.data[0]);
                const colWidths = headers.map((header) => ({ wch: header.length + 2 }));

                worksheet['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setExportDataListLoading(false);
        }
    };

    const { data: loginUsernameOptions } = useFetchData('/Customer/LoginUserNames');

    return (
        <Grid container item xs={12} padding="20px">
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterDateFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterDateFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterDateTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterDateTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Login UserName :
                        </Typography>
                        <Autocomplete
                            freeSolo
                            value={filterLoginUsername}
                            onChange={(event, newValue) => {
                                setFilterLoginUsername(newValue);
                            }}
                            inputValue={filterLoginUsername}
                            onInputChange={(event, newInputValue) => {
                                setFilterLoginUsername(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={loginUsernameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Is Withdraw : 
                        </Typography>
                        <FormControl fullWidth>
                            <Select
                                displayEmpty
                                value={filterIsWithdraw}
                                onChange={(e) => setFilterIsWithdraw(e.target.value)}
                                // sx={{width:"100%"}}
                            >
                                <MenuItem value="">Select Status</MenuItem>
                                <MenuItem value="True">True</MenuItem>
                                <MenuItem value="False">False</MenuItem>
                                
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={12} lg={12}>
                    <Button
                        variant="contained"
                        sx={{
                            float: 'right',
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '30px'
                        }}
                        onClick={() => fetchWalletInvestmentRecord()}
                        disabled={filterBtnDisabled}
                    >
                        Filter
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => exportDataAsXlsx()}
                        disabled={filterBtnDisabled}
                    >
                        Export Data
                    </Button>
                </Grid>
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable walletInvestment={walletInvestment}/>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default EarnWalletInvestment;
